// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
export function isPromise(promise) {
    return !isNil(promise) && typeof promise.then === 'function';
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
export function isFunction(fun) {
    return !isNil(fun) && typeof fun === 'function';
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
export function isString(text) {
    return !isNil(text) && (typeof text === 'string' || text instanceof String);
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
export function isNil(value) {
    return value === undefined || value === null;
}
//# sourceMappingURL=utils.js.map